import React, { useState } from 'react';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import ReportTechnicalDifficultiesForm from './ReportTechnicalDifficultiesForm';

const ReportTechnicalDifficulties = ({ skipRecording, disabled }) => {
  const [showReportTechnicalDifficulties, setShowReportTechinicalDifficulties] =
    useState(false);
  const [showFeedbackTextSection, setShowFeedbackTextSection] = useState(true);
  const [showSkippedSuccess, setShowSkippedSuccess] = useState(false);

  const handleShowReportTechnicalDifficulties = () => {
    setShowReportTechinicalDifficulties(!showReportTechnicalDifficulties);
  };

  const handleShowSkippedSuccess = (feedback, reason) => {
    setShowReportTechinicalDifficulties(false);
    setShowFeedbackTextSection(false);
    skipRecording(feedback, reason);
    setShowSkippedSuccess(!showSkippedSuccess);
  };

  return (
    <div className="fz-16 pos-r">
      {showFeedbackTextSection && (
        <>
          <Text className="mr-4" variant={TEXT_VARIANTS.BODY_LIGHT}>
            {t(
              'practice.on_demand_practice.audio_recording.skip_recording.technical_difficulties_text',
            )}
          </Text>
          <a
            href="https://intercom.help/lessonly/en/articles/3369515-troubleshooting-for-recording-functionalities"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Text variant={TEXT_VARIANTS.BODY_LINK}>
              {t(
                'practice.on_demand_practice.audio_recording.skip_recording.article_link_text',
              )}
            </Text>
          </a>
          <Text variant={TEXT_VARIANTS.BODY_LIGHT}> {t('common.or')} </Text>
          <button
            className=" u-linkBtn"
            type="button"
            onClick={handleShowReportTechnicalDifficulties}
          >
            {t(
              'practice.on_demand_practice.audio_recording.skip_recording.submit_feedback_link_text',
            )}
          </button>
        </>
      )}
      {showReportTechnicalDifficulties && (
        <ReportTechnicalDifficultiesForm
          handleShowReportTechnicalDifficulties={
            handleShowReportTechnicalDifficulties
          }
          handleShowSkippedSuccess={handleShowSkippedSuccess}
          disabled={disabled}
        />
      )}
    </div>
  );
};

export default ReportTechnicalDifficulties;
